/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Local storage API services
  Date: April 2020
**/

const LocalStorageService = (function () {
  let _service;
  function _getService() {
    if (!_service) {
      _service = service;
    }
    return _service;
  }

  function _setBrandingInfo(obj) {
    localStorage.setItem('brandingInfo', obj);
  }

  function _getBrandingInfo() {
    return localStorage.getItem('brandingInfo');
  }

  function _getToken() {
    return null;
  }

  const service = {
    getBrandingInfo: _getBrandingInfo,
    getService: _getService,
    getToken: _getToken,
    setBrandingInfo: _setBrandingInfo,
  };

  return service;
})();
export default LocalStorageService;
